import { TaxonomyListPage } from '../taxonomy/TaxonomyListPage.js';

export function CarCategoryListPage() {
  return (
    <TaxonomyListPage
      config={{
        title: 'Car Categories',
        description: 'Vehicle classes for display and filtering (SUV, Sedan…).',
        apiPath: '/car-categories',
        basePath: '/car-categories',
        resource: 'carCategory',
        subject: 'CarCategory',
        entityLabel: 'category',
      }}
    />
  );
}
